import { render, staticRenderFns } from "./content_filtering.vue?vue&type=template&id=5bd91383&"
import script from "./content_filtering.vue?vue&type=script&lang=js&"
export * from "./content_filtering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./content_filtering.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports